import { render, staticRenderFns } from "./DoctorRegisterModal.vue?vue&type=template&id=c5be13c6&scoped=true&slot=footer&"
import script from "./DoctorRegisterModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterModal.vue?vue&type=style&index=0&id=c5be13c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5be13c6",
  null
  
)

export default component.exports